import { RoommateData } from './types';

export const roommateDataKeys: { [K in keyof RoommateData]: K } = {
    first_name: 'first_name',
    last_name: 'last_name',
    email: 'email',
};

// Number of objects inside of array will depend on number of roommates
export const roommates: RoommateData[] = [
    { first_name: '', last_name: '', email: '' },
    { first_name: '', last_name: '', email: '' },
    { first_name: '', last_name: '', email: '' },
];

export const defaultValues = {
    roommates,
};

export type RoommateFormValues = {
    roommates: RoommateData[];
};
